var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.999,
    viewBox: "0 0 20 14.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M7.5,10A3.75,3.75,0,1,0,3.75,6.25,3.75,3.75,0,0,0,7.5,10ZM10,6.25a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,10,6.25Zm5,10a1.224,1.224,0,0,1-1.25,1.25H1.25A1.224,1.224,0,0,1,0,16.249c0-1.25,1.25-5,7.5-5S15,15,15,16.249Zm-1.25,0a3.34,3.34,0,0,0-1.04-2.08c-.815-.815-2.349-1.665-5.21-1.665s-4.395.85-5.21,1.665a3.347,3.347,0,0,0-1.04,2.08Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M19.816,6.432a.625.625,0,0,1,0,.885l-3.75,3.75a.625.625,0,0,1-.885,0L13.307,9.192a.626.626,0,1,1,.885-.885l1.432,1.434,3.307-3.309a.625.625,0,0,1,.885,0Z",
    fill: "#6B7280",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGrey);
export default __webpack_public_path__ + "static/media/profile-grey.9e9e909e7fc34e09c5117b1dbdd444a0.svg";
export { ForwardRef as ReactComponent };